module.exports = __webpack_public_path__ + "static/media/chinese-flag.0b09c66b.svg";